export default (function (value) {
  return typeof value === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isFunction.js
// module id = 226
// module chunks = 0